import React, { useEffect, useState } from 'react';
import { Alert, Button, FormControl, FormControlLabel, Grid, IconButton, InputLabel, MenuItem, Radio, RadioGroup, Select, TextField, Typography, useMediaQuery } from '@mui/material';
import { Controller, useForm } from 'react-hook-form';
import { accountOptionArray, contributionTypeArray, pacFrequencyList, radioColorSx } from 'store/constant';
// import { ToastContainer, toast } from 'react-toastify';
import AddIcon from '@mui/icons-material/Add';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker';
import { Stack } from '@mui/system';
import axiosInstance from 'custom-axios';
import { ToastContainer, toast } from 'react-toastify';
import NumberFormat from 'react-number-format';
import DeleteIcon from '@mui/icons-material/Delete';
import { useFullPageLoader } from 'hooks/useFullPageLoader';
import { showConfirmSweetAlert } from 'hooks/useSweetAlert';



const PacInformation = ({ accountTypeId, pacRef, userId, setAccountPacData, formAccountData, setFormAccountData, activeAccountStep, setActiveAccountStep }) => {

    const today = new Date();
    const minDate = new Date();
    minDate.setDate(today.getDate() + 5);

    // Calculate the last date of the next month
    const maxDate = new Date(today.getFullYear(), today.getMonth() + 2, 0);
    const [loader, showLoader, hideLoader] = useFullPageLoader();
    const matchesMD = useMediaQuery((theme) => theme.breakpoints.down('md'));
    const [bankDetails, setBankDetails] = useState([
        ...formAccountData.pac_details
    ]);
    // const [accountTypeId, setAccountTypeId] = useState(1)
    const [selectedBankAccountNumber, setSelectedBankAccountNumber] = useState('');
    const [filteredAccountDetails, setFilteredAccountDetails] = useState([]);
    const [transferDetails, setTransferDetails] = useState(formAccountData.transfer_details);
    const [hideFormData, setHideFormData] = useState(false)

    const {
        register,
        control,
        handleSubmit,
        setValue,
        trigger,
        formState: { errors }
    } = useForm({
        mode: 'submitClientForm',
        // resolver: yupResolver(householdValidation),
    });

    React.useImperativeHandle(pacRef, () => ({
        triggerValidation: async () => {
            const isValid = await trigger();
            return isValid;
        }
    }));



    // for showing bank account data after selecting bank account
    const fetchBankingData = async () => {
        try {
            const response = await axiosInstance.get(`api/get-user-bank-info/${userId}`);

            if (response.data.length > 0) {

                setTransferDetails(response.data);
                // const defaultBankAccountNumber = response.data[0].bank_account_number;

                // const filteredData = response.data.filter(
                //     (detail) => detail.bank_account_number === defaultBankAccountNumber
                // );
                // setFilteredAccountDetails(filteredData);
            }

        } catch (error) {
            // console.error(error.message);
        }
    }

    const fetchPacData = async () => {
        try {
            const response = await axiosInstance.get(`api/get-user-pac-info/${userId}`);

            setHideFormData(response.is_applicable)

            if (response.data) {

                setFormAccountData(prevFormData => ({
                    ...prevFormData,
                    ...response.data[0],
                }));

                let dataFilter = []


                if (response.data[0]) {
                    setBankDetails(response.data);
                    dataFilter = response.data
                } else {
                    setBankDetails([response.data]);
                    dataFilter = [response.data]
                }


                const defaultBankAccountNumber = dataFilter[0].bank_account_number;
                setSelectedBankAccountNumber(defaultBankAccountNumber)


                const filteredData = dataFilter.map((item) => ({
                    account_type_id: item.account_type_id,
                    bank_account_number: item.bank_account_number,
                    bank_currency: item.bank_currency,
                    bank_institution_number: item.bank_institution_number,
                    bank_name: item.bank_name,
                    bank_transit_number: item.bank_transit_number,
                    id: item.id,
                    user_id: item.user_id,
                    /* created_at: item.created_at,
                    updated_at: item.updated_at,
                    void_cheque_file: item.void_cheque_file */
                }));
                setFilteredAccountDetails(filteredData);

                setValue('pac_start_date', response.data[0].pac_start_date)
                setValue('pac_frequency', response.data[0].pac_frequency)
                setValue('pac_account_option', response.data[0].pac_account_option)
            }
        } catch (error) {
            // console.error(error.message);
        }
    }


    const fetchAccountTypeInfoData = async () => {
        try {
            const response = await axiosInstance.get(`api/get-user-account-type-info/${userId}`);

            if (response.data) {
                setFormAccountData(prevFormData => ({
                    ...prevFormData,
                    account_transfer: response.data.account_transfer,
                    account_eft: response.data.account_eft,
                    account_pac: response.data.account_pac,
                    account_swp: response.data.account_swp,
                    account_income_sweep: response.data.account_income_sweep,
                }));
            }
        } catch (error) {
            // console.error(error.message);
        }
    }

    const handleTransferChange = (value, index, name) => {
        const updatedPolicies = [...bankDetails];
        updatedPolicies[0].plan_investment_instruction[index][name] = value;
        setBankDetails(updatedPolicies);

        setAccountPacData((prevData => ({
            ...prevData,
            ...updatedPolicies
        })))
    };

    const addNewTemplate = () => {

        const updatedPolicies = [...bankDetails];
        updatedPolicies[0].plan_investment_instruction.push({
            id: '',
            pii_contribution_type: '',
            pii_fund_number: '',
            pii_fund_name: '',
            pii_gross_amount: ''
        });
        setBankDetails(updatedPolicies);
    };

    const removePacInstruction = async (index, id, pacId) => {

        if (id) {

            const result = await showConfirmSweetAlert({
                title: 'Remove Item?',
                text: 'Are you sure you want to remove this?',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Yes, remove it!',
                cancelButtonText: 'No, cancel!',
            });

            if (result.isConfirmed) {

                showLoader()
                try {
                    const response = await axiosInstance.delete(`api/delete-pac-instruction/${id}/${pacId}`);

                    hideLoader()

                    if (response.status == 200) {
                        toast.success(response.message);
                        fetchAllApi();
                    } else {
                        toast.error(response.message);
                    }

                } catch (error) {
                    toast.error(error.message);
                }
            }

        } else {
            const updatedTransferDetails = [...bankDetails];
            updatedTransferDetails[0].plan_investment_instruction.splice(index, 1);
            setBankDetails(updatedTransferDetails);
        }
    }

    const handleRoleBack = async () => {

        let endPoint = `api/change-form-step`;

        let modifiedChildStep = activeAccountStep - 1

        // if (formAccountData.account_eft == 2) {
        //     modifiedChildStep = 3
        // }


        const submitData = { user_id: userId ? userId : 0, parent_step: 1, child_step: modifiedChildStep }

        try {
            const response = await axiosInstance.post(endPoint, submitData);

            if (response.status === 200) {
                setActiveAccountStep(modifiedChildStep);
            }

        } catch (error) {
            // console.error(error)
            toast.error('An error occurred when navigating back.')
        }
    };

    const handleBankAccountChange = (event) => {
        const bankAccountNumber = event.target.value;
        setSelectedBankAccountNumber(bankAccountNumber);
        const filteredData = transferDetails.filter(
            (detail) => detail.bank_account_number === bankAccountNumber
        );

        setFilteredAccountDetails(filteredData);

        setAccountPacData((prevData => ({
            ...prevData,
            bank_account_number: filteredData[0].bank_account_number,
            bank_name: filteredData[0].bank_name,
            bank_transit_number: filteredData[0].bank_transit_number,
            bank_institution_number: filteredData[0].bank_institution_number,
        })))

    };
    // console.log(errors)

    const submitForm = async () => {

        setFormAccountData(prevData => ({
            ...prevData,
            plan_investment_instruction: bankDetails
        }));

        let endPoint = `api/save-user-pac-info`;

        let modifiedChildStep = activeAccountStep + 1;

        // if (formAccountData.account_swp == 2 && formAccountData.account_income_sweep == 2) {
        //     modifiedChildStep = 7;

        // } else {
        //     const stepsToCheck = [
        //         { stepIndex: 6, value: formAccountData.account_swp },
        //         { stepIndex: 7, value: formAccountData.account_income_sweep },
        //     ];

        //     // Find the highest-priority step where the value is 1
        //     for (const step of stepsToCheck) {
        //         if (step.value === 1) {
        //             modifiedChildStep = step.stepIndex;
        //             break;
        //         }
        //     }
        // }

        const submitData = { ...bankDetails[0], ...filteredAccountDetails[0], login_id: formAccountData.login_id, accountTypeId: accountTypeId, user_id: userId ? userId : 0, parent_step: 1, child_step: modifiedChildStep }

        try {
            const response = await axiosInstance.post(endPoint, submitData);

            if (response.status === 200) {
                setActiveAccountStep(modifiedChildStep);
            }

        } catch (error) {
            // console.error(error)
        }
    }

    const fetchAllApi = async () => {
        await fetchPacData()
        await fetchAccountTypeInfoData()
        fetchBankingData()
    }

    useEffect(() => {
        fetchAllApi()
    }, [])

    // console.log(hideFormData)

    return (
        <>

            <form onSubmit={handleSubmit(submitForm)}>
                {hideFormData &&
                    <div className='container'>
                        <div className='mt-3 width100'>
                            {bankDetails[0].plan_investment_instruction?.map((item, index) => (
                                <React.Fragment key={index}>
                                    <Grid
                                        container
                                        direction="row"
                                        justifyContent="space-between"
                                        alignItems="center"
                                        className='form-head-gray-title'
                                    >

                                        <Grid item>
                                            <Typography component={'h3'}>Plan Investment Instruction #{index + 1}</Typography>
                                        </Grid>

                                        <Grid item>
                                            <IconButton sx={{ p: "0 10px 0 0" }} disabled={index == 0} onClick={() => removePacInstruction(index, item.id, bankDetails[0].pac_id)}>
                                                <DeleteIcon />
                                            </IconButton>
                                        </Grid>
                                    </Grid>

                                    <Grid container spacing={2} className='p-4'>
                                        <Grid item xs={12} sm={6} md={4} className={`align-content-center ${matchesMD ? '' : 'text-right'}`}>
                                            <label htmlFor="contribution_type" className='font15px'>Contribute Type</label>
                                        </Grid>
                                        <Grid item xs={12} sm={6} md={4}>
                                            <FormControl component="fieldset">
                                                <RadioGroup
                                                    row
                                                    id='contribution-type'
                                                    name='pii_contribution_type'
                                                    value={item.pii_contribution_type}
                                                    onChange={(e) => handleTransferChange(e.target.value, index, 'pii_contribution_type')}
                                                >
                                                    {contributionTypeArray.map((option) => (
                                                        <FormControlLabel
                                                            key={option.value}
                                                            value={option.value}
                                                            control={<Radio sx={radioColorSx} />}
                                                            label={option.label}
                                                        />
                                                    ))}
                                                </RadioGroup>
                                            </FormControl>
                                        </Grid>
                                        <Grid item xs={12} sm={12} md={4}></Grid>

                                        <Grid item xs={12} sm={6} md={4} className={`align-content-center ${matchesMD ? '' : 'text-right'}`}>
                                            <label htmlFor="pii_fund_number" className='font15px'>Fund Number</label>
                                        </Grid>
                                        <Grid item xs={12} sm={6} md={4}>
                                            <TextField
                                                label="Fund Number"
                                                fullWidth
                                                size="small"
                                                name='pii_fund_number'
                                                onChange={(e) => handleTransferChange(e.target.value, index, 'pii_fund_number')}
                                                value={item.pii_fund_number}
                                            />
                                        </Grid>
                                        <Grid item xs={12} sm={12} md={4}></Grid>

                                        <Grid item xs={12} sm={6} md={4} className={`align-content-center ${matchesMD ? '' : 'text-right'}`}>
                                            <label htmlFor="pii_fund_name" className='font15px'>Fund Name</label>
                                        </Grid>
                                        <Grid item xs={12} sm={6} md={4}>
                                            <TextField
                                                label="Fund Name"
                                                fullWidth
                                                size="small"
                                                name='pii_fund_name'
                                                onChange={(e) => handleTransferChange(e.target.value, index, 'pii_fund_name')}
                                                value={item.pii_fund_name}
                                            />
                                        </Grid>
                                        <Grid item xs={12} sm={12} md={4}></Grid>

                                        <Grid item xs={12} sm={6} md={4} className={`align-content-center ${matchesMD ? '' : 'text-right'}`}>
                                            <label htmlFor="pii_gross_amount" className='font15px'>Gross Amount</label>
                                        </Grid>
                                        <Grid item xs={12} sm={6} md={4}>
                                            <NumberFormat
                                                customInput={TextField}
                                                prefix="$"
                                                allowNegative={false}
                                                label="Gross Amount"
                                                name="pii_gross_amount"
                                                value={item.pii_gross_amount}
                                                variant="outlined"
                                                thousandSeparator={true}
                                                size='small'
                                                fullWidth
                                                onValueChange={(values) => {
                                                    handleTransferChange(values.value, index, 'pii_gross_amount');
                                                }}
                                            />
                                        </Grid>
                                        <Grid item xs={12} sm={12} md={4}></Grid>
                                    </Grid>
                                </React.Fragment>
                            ))}
                            <Button startIcon={<AddIcon />} onClick={() => addNewTemplate()}>
                                Add Plan Investment Instruction
                            </Button>
                        </div>

                        <Grid container spacing={2} className='p-4'>
                            <Grid item xs={12}>
                                <Typography variant='h3' className='form-head-gray-title'>Pre-Authorization Contribution</Typography>
                            </Grid>

                            <Grid item xs={12} sm={6} md={4} className={`align-content-center ${matchesMD ? '' : 'text-right'}`}>
                                <label htmlFor="contribution_type" className='font15px'>Frequency</label>
                            </Grid>

                            <Grid item xs={12} sm={6} md={4}>
                                <FormControl
                                    fullWidth
                                    size="small"
                                    error={Boolean(errors && errors['pac_frequency'])}
                                >
                                    <InputLabel id="select-contact-application">Frequency</InputLabel>
                                    <Select
                                        labelId="select-contact-application"
                                        label="Province"
                                        value={bankDetails[0].pac_frequency || ''}
                                        classes={{ select: "custom-select-label" }}
                                        MenuProps={{
                                            disableScrollLock: true,
                                            PaperProps: { sx: { maxHeight: 200 } }
                                        }}
                                        onChange={(e) => {
                                            const updatedBankDetails = [...bankDetails];
                                            updatedBankDetails[0].pac_frequency = e.target.value; // Update the frequency in the bankDetails array
                                            setBankDetails(updatedBankDetails);
                                        }}
                                        inputProps={register('pac_frequency', {
                                            required: true
                                        })}
                                    >
                                        {pacFrequencyList.map((option) => (
                                            <MenuItem key={option.value} value={option.value}>
                                                {option.label}
                                            </MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={12} md={4}></Grid>

                            <Grid item xs={12} sm={6} md={4} className={`align-content-center ${matchesMD ? '' : 'text-right'}`}>
                                <label htmlFor="pac-start-date" className='font15px'>Start Date</label>
                            </Grid>
                            <Grid item xs={12} sm={6} md={4}>

                                <LocalizationProvider dateAdapter={AdapterDateFns}>
                                    <Stack spacing={3}>
                                        <Controller
                                            name="pac_start_date"
                                            control={control}
                                            rules={{
                                                required: 'Start date is required',
                                                validate: {
                                                    minDate: (value) =>
                                                        new Date(value) >= minDate || `Date must be after ${minDate.toISOString().split('T')[0]}`,
                                                    maxDate: (value) =>
                                                        new Date(value) <= maxDate || `Date must be before ${maxDate.toISOString().split('T')[0]}`,
                                                },
                                            }}
                                            render={({ field }) => (
                                                <DesktopDatePicker
                                                    label="Start Date"
                                                    inputFormat="yyyy/MM/dd"
                                                    value={field.value || null}
                                                    onChange={(newValue) => {
                                                        field.onChange(newValue); // for react-hook-form
                                                        const updatedBankDetails = [...bankDetails];
                                                        updatedBankDetails[0].pac_start_date = newValue;
                                                        setBankDetails(updatedBankDetails);
                                                    }}
                                                    minDate={minDate}
                                                    maxDate={maxDate}
                                                    renderInput={(params) => (
                                                        <TextField
                                                            {...params}
                                                            fullWidth
                                                            size="small"
                                                            error={Boolean(errors.pac_start_date)}
                                                            helperText={errors.pac_start_date?.message}
                                                        />
                                                    )}
                                                />
                                            )}
                                        />
                                    </Stack>
                                </LocalizationProvider>
                            </Grid>
                            <Grid item xs={12} sm={12} md={4}></Grid>


                            <Grid item xs={12} sm={6} md={4} className={`align-content-center ${matchesMD ? '' : 'text-right'}`}>
                                <label htmlFor="contribution_type" className='font15px'>Account Option</label>
                            </Grid>

                            <Grid item xs={12} sm={6} md={4}>
                                <FormControl
                                    fullWidth
                                    size="small"
                                    error={Boolean(errors && errors['pac_account_option'])}
                                >
                                    <InputLabel id="select-account-option">Account Option</InputLabel>
                                    <Select
                                        labelId="select-account-option"
                                        label="Account Option"
                                        value={bankDetails[0].pac_account_option || ''}
                                        classes={{ select: "custom-select-label" }}
                                        MenuProps={{
                                            disableScrollLock: true,
                                            PaperProps: { sx: { maxHeight: 200 } }
                                        }}
                                        onChange={(e) => {
                                            const updatedBankDetails = [...bankDetails];
                                            updatedBankDetails[0].pac_account_option = e.target.value; // Update the account option in the bankDetails array
                                            setBankDetails(updatedBankDetails);
                                        }}
                                        inputProps={register('pac_account_option', {
                                            required: true
                                        })}
                                    >
                                        {accountOptionArray.map((option) => (
                                            <MenuItem key={option.value} value={option.value}>
                                                {option.label}
                                            </MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>

                            </Grid>
                            <Grid item xs={12} sm={12} md={4}></Grid>
                            {/* {console.log(bankDetails)} */}

                            {(bankDetails[0].pac_account_option == 1) &&
                                <>
                                    <Grid item xs={12} sm={6} md={4} className={`align-content-center ${matchesMD ? '' : 'text-right'}`}>
                                        <label htmlFor="contribution_type" className='font15px'>Select Existing Investment Account</label>
                                    </Grid>

                                    <Grid item xs={12} sm={6} md={4}>
                                        <FormControl
                                            fullWidth
                                            size="small"
                                        // error={Boolean(errors && errors['pac_investment_account_detail_id'])}
                                        >
                                            <InputLabel id="select-account-details">Investment Account</InputLabel>
                                            <Select
                                                labelId="select-account-details"
                                                label="Investment Account"
                                                value={bankDetails[0].pac_investment_account_detail_id || ''}
                                                classes={{ select: "custom-select-label" }}
                                                MenuProps={{
                                                    disableScrollLock: true,
                                                    PaperProps: { sx: { maxHeight: 200 } }
                                                }}
                                                onChange={(e) => {
                                                    // console.log(e.target)
                                                    const updatedBankDetails = [...bankDetails];
                                                    // console.log(updatedBankDetails)
                                                    updatedBankDetails[0].pac_investment_account_detail_id = e.target.value; // Update the account option in the bankDetails array
                                                    setBankDetails(updatedBankDetails);
                                                }}

                                                inputProps={register('pac_investment_account_detail_id', {
                                                    // onChange: (e) => { console.log(e.target) },
                                                    required: true
                                                })}
                                            >
                                                {bankDetails[0].pac_investment_account_details.map((option) => (
                                                    // console.log(option)
                                                    <MenuItem key={option.id} value={option.id}>
                                                        {option.label}
                                                    </MenuItem>
                                                ))}
                                            </Select>
                                        </FormControl>

                                    </Grid>
                                    <Grid item xs={12} sm={12} md={4}></Grid>
                                </>
                            }

                            {(bankDetails[0].pac_account_option == 2) &&
                                <>
                                    <Grid item xs={12} sm={6} md={4} className={`align-content-center ${matchesMD ? '' : 'text-right'}`}>
                                        <label htmlFor="bank-name" className='font15px'>Account Number</label>
                                    </Grid>
                                    <Grid item xs={12} sm={6} md={4}>
                                        <FormControl
                                            fullWidth
                                            size="small"
                                        >
                                            <InputLabel id="select-tpi-instruction_currency">Account Number</InputLabel>
                                            <Select
                                                labelId="select-tpi-instruction_currency"
                                                label="Account Number"
                                                value={selectedBankAccountNumber}
                                                classes={{ select: "custom-select-label" }}
                                                name='instruction_currency'
                                                MenuProps={{
                                                    disableScrollLock: true,
                                                    PaperProps: { sx: { maxHeight: 200 } }
                                                }}
                                                onChange={handleBankAccountChange}
                                            >
                                                {transferDetails.map((detail) => (
                                                    <MenuItem key={detail.id} value={detail.bank_account_number}>
                                                        {detail.bank_account_number}
                                                    </MenuItem>
                                                ))}
                                            </Select>
                                        </FormControl>
                                    </Grid>
                                    <Grid item xs={12} sm={12} md={4}></Grid>

                                    {filteredAccountDetails?.map((item, index) => {
                                        return (
                                            <React.Fragment key={index}>
                                                <Grid item xs={12} sm={6} md={4} className={`align-content-center ${matchesMD ? '' : 'text-right'}`}>
                                                    <label htmlFor="bank-name" className='font15px'>Name Of Bank</label>
                                                </Grid>
                                                <Grid item xs={12} sm={6} md={4}>
                                                    <TextField
                                                        label="Name Of Bank"
                                                        fullWidth
                                                        InputLabelProps={item.bank_name ? { shrink: true } : {}}
                                                        size="small"
                                                        name='bank_name'
                                                        disabled
                                                        value={item.bank_name}
                                                    />
                                                </Grid>
                                                <Grid item xs={12} sm={12} md={4}></Grid>


                                                <Grid item xs={12} sm={6} md={4} className={`align-content-center ${matchesMD ? '' : 'text-right'}`}>
                                                    <label htmlFor="bank_transit_number" className='font15px'>Bank Transit Number</label>
                                                </Grid>
                                                <Grid item xs={12} sm={6} md={4}>
                                                    <TextField
                                                        label="Bank Transit Number"
                                                        fullWidth
                                                        size="small"
                                                        name='bank_transit_number'
                                                        disabled
                                                        InputLabelProps={item.bank_transit_number ? { shrink: true } : {}}
                                                        value={item.bank_transit_number}
                                                    />
                                                </Grid>
                                                <Grid item xs={12} sm={12} md={4}></Grid>


                                                <Grid item xs={12} sm={6} md={4} className={`align-content-center ${matchesMD ? '' : 'text-right'}`}>
                                                    <label htmlFor="bank_institution_number" className='font15px'>Institution Number</label>
                                                </Grid>
                                                <Grid item xs={12} sm={6} md={4}>

                                                    <TextField
                                                        label="Institution Number"
                                                        fullWidth
                                                        size="small"
                                                        name='bank_institution_number'
                                                        disabled
                                                        InputLabelProps={item.bank_institution_number ? { shrink: true } : {}}
                                                        value={item.bank_institution_number}
                                                    />
                                                </Grid>
                                                <Grid item xs={12} sm={12} md={4}></Grid>
                                            </React.Fragment>
                                        )
                                    })}
                                </>
                            }
                        </Grid>

                    </div>

                }

                {!hideFormData &&
                    <div className='container'>
                        <Grid item spacing={2} className='p-4'>
                            <Alert
                                severity='info'
                                className='font14px cursor-pointer'
                            // onClick={handleClickExternalInvestmentOpen}
                            >
                                This client's account(s) are not applicable for Pac.
                            </Alert>
                        </Grid>
                    </div>
                }

                <Grid item xs={12} sm={6} className='pt-3 text-center'>
                    <Button variant='contained' className='m-3 raintree-btn-green' onClick={handleRoleBack}>
                        Back
                    </Button>
                    <Button variant='contained' className='m-3 raintree-btn-green' type='submit'>
                        Next
                    </Button>
                </Grid>
            </form >
            {loader}
            < ToastContainer />
        </>
    )
}

export default PacInformation